// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_GetAvailableDespesasForPayrollPeriodResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /despesas/getAvailableDespesasForPayrollPeriod
 *
 * Returns a list of despesas (expenses) available for payroll period processing.
 * Used exclusively by the ExpenseConciliationWizard to fetch expenses not yet
 * assigned to a payroll period.
 *
 * Each item is typed via Despesas_GetAvailableDespesasForPayrollPeriodRow,
 * which mirrors the SELECT in Despesas_Model::getAvailableDespesasForPayrollPeriod()
 * (column types + aliases + the `franquia` enrichment from
 * inserePropriedadeMany).
 *
 * @see Despesas_Model::getAvailableDespesasForPayrollPeriod() for the source query
 * @see Despesas_GetAvailableDespesasForPayrollPeriodRow for per-field types
 */
import type { Despesas_GetAvailableDespesasForPayrollPeriodRow } from './Despesas_GetAvailableDespesasForPayrollPeriodRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Despesas_GetAvailableDespesasForPayrollPeriodResponseDados = Despesas_GetAvailableDespesasForPayrollPeriodRow[];

export type Despesas_GetAvailableDespesasForPayrollPeriodResponse = ApiResponse<Despesas_GetAvailableDespesasForPayrollPeriodResponseDados>;

registerResponseContract('Despesas_GetAvailableDespesasForPayrollPeriodResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      despesa_id:                        { type: 'number',  required: true },
      despesa_franquia_id:               { type: 'number',  required: true },
      status:                            { type: 'string',  required: false },
      despesa_status_id:                 { type: 'number',  required: true },
      categoria:                         { type: 'string',  required: false },
      categoria_raw:                     { type: 'string',  required: true },
      despesa_titulo:                    { type: 'string',  required: true },
      despesa_valor:                     { type: 'number',  required: true },
      despesa_tipo_mensal:               { type: 'number',  required: true },
      despesa_descricao:                 { type: 'string',  required: false },
      despesa_data_vencimento:           { type: 'string',  required: false },
      despesa_data_lancamento:           { type: 'string',  required: true },
      data_vencimento:                   { type: 'string',  required: false },
      data_lancamento:                   { type: 'string',  required: true },
      parcela:                           { type: 'string',  required: true },
      despesa_generated_from_payroll:    { type: 'number',  required: true },
      despesa_generated_from_payroll_id: { type: 'number',  required: false },
      despesa_payroll_period_id:         { type: 'number',  required: false },
      franquia:                          { type: 'string',  required: false },
    },
  },
})
